<template>
  <div>
    <b-modal
      id="modal-edit"
      size="lg"
      centered
      :title="$store.state.modal.editPosisi"
      header-bg-variant="warning"
      header-text-variant="light"
    >
      <b-form>
        <b-form-group :label="$store.state.form.divisi" label-cols-md="3">
          <multiselect
            :state="checkIfValid('masterDivisi')"
            v-model="$v.dataEdit.masterDivisi.$model"
            :options="divisi"
            :multiple="false"
            :searchable="true"
            :close-on-select="true"
            :show-labels="false"
            label="namaDivisi"
            track-by="id"
            placeholder="-- Pilih --"
          ></multiselect>
        </b-form-group>
        <b-form-group :label="$store.state.form.kode" label-cols-md="3">
          <b-form-input
            type="text"
            :state="checkIfValid('kodePosisi')"
            v-model="$v.dataEdit.kodePosisi.$model"
          ></b-form-input>
        </b-form-group>
        <b-form-group :label="$store.state.form.posisi" label-cols-md="3">
          <b-form-input
            type="text"
            :state="checkIfValid('namaPosisi')"
            v-model="$v.dataEdit.namaPosisi.$model"
          ></b-form-input>
        </b-form-group>
      </b-form>
      <!-- <img :src="src1" /> -->
      <template #modal-footer>
        <b-button variant="secondary" @click="$bvModal.hide('modal-edit')">
          Tutup
        </b-button>
        <b-button
          variant="primary"
          :disabled="busy || !isValid"
          @click="simpan()"
        >
          {{ button }}
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
export default {
  name: "modalEdit",
  props: ["data", "divisi", "edit"],
  data() {
    return {
      dataEdit: {
        kodePosisi: "",
        namaPosisi: "",
        masterDivisi: "",
      },
      busy: false,
      button: "Simpan",
    };
  },
  computed: {
    formString() {
      return JSON.stringify(this.dataEdit, null, 4);
    },
    isValid() {
      return !this.$v.dataEdit.$invalid;
    },
    isDirty() {
      return this.$v.dataEdit.$anyDirty;
    },
  },
  mixins: [validationMixin],
  validations: {
    dataEdit: {
      namaPosisi: {
        required,
      },
      kodePosisi: {
        required,
      },
      masterDivisi: {
        required,
      },
    },
  },
  watch: {
    edit: function (newVal, oldVal) {
      if (oldVal != newVal) {
        let vm = this;
        // FOREACH diganti FOR
        // vm.divisi.forEach((ele) => {
        //   if (ele.id == vm.data.masterDivisiId) {
        //     vm.data.masterDivisi = ele;
        //   }
        // });
        for (let i = 0; i < vm.divisi.length; i++) {
          if (vm.divisi[i].masterDivisiId == vm.data.masterDivisiId) {
            vm.dataEdit.masterDivisi = vm.divisi[i];
          }
          vm.dataEdit.namaPosisi = vm.data.namaPosisi;
          vm.dataEdit.kodePosisi = vm.data.kodePosisi;
        }
        // for (let j = 0; j < vm.options.length; j++) {
        //   const elOptions = vm.options[j]

        //   for (let k = 0; k < elOptions.pilihan.length; k++) {
        //     const elDataOptions = elOptions.pilihan[k];
        //     if (elDataOptions.value == vm.data.kodePosisi) {
        //       vm.dataEdit.kodePosisi = elDataOptions
        //     }
        //   }
        //     // if (elData.value == vm.data.kodePosisi) {
        //     //   vm.dataEdit.kodePosisi = elData.text
        //     // }

        // }
      }
    },
  },
  methods: {
    checkIfValid(fieldName) {
      const field = this.$v.dataEdit[fieldName];
      if (!field.$dirty) {
        return null;
      }
      return !(field.$invalid || field.$model === "");
    },

    simpan() {
      let vm = this;
      vm.busy = true;
      vm.button = "Mohon Tunggu";
      vm.data.masterDivisiId = vm.dataEdit.masterDivisi.masterDivisiId;
      vm.data.namaPosisi = vm.dataEdit.namaPosisi;
      vm.data.kodePosisi = vm.dataEdit.kodePosisi;
      vm.data.id = vm.data.masterPosisiId;
      vm.$axios
        .post("masterPosisi/update", vm.data)
        .then((res) => {
          if (res.data.message == "sukses") {
            vm.button = "Simpan";
            vm.busy = false;
            vm.$emit("alertFromChild", {
              variant: "success",
              msg: "BERHASIL MENGUBAH MASTER POSISI",
              showing: true,
            });
            this.$bvModal.hide("modal-edit");
          } else {
            vm.button = "Simpan";
            vm.busy = false;
            vm.$emit("alertFromChild", {
              variant: "danger",
              msg: res.data.message.toUpperCase(),
              showing: true,
            });
          }
        })
        .catch((err) => {
          err;
          vm.button = "Simpan";
          vm.busy = false;
          vm.$emit("alertFromChild", {
            variant: "danger",
            msg: "TERJADI KESALAHAN PADA SERVER",
            showing: true,
          });
        });
    },
  },
};
</script>
